import { render, staticRenderFns } from "./retailer.vue?vue&type=template&id=014f20a6"
import script from "./retailer.vue?vue&type=script&lang=js"
export * from "./retailer.vue?vue&type=script&lang=js"
import style0 from "./retailer.vue?vue&type=style&index=0&id=014f20a6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports